import Api from "../../../Services/Api";
import { fetchDataAsync } from "../../../Services/Utils";

export const fetchDataItem = async (type, body) => {
  console.log(body);

  switch (type) {
    case "QR":
      try {
        const res = await Api.create(
          "NAGAMAS_MASTER_DATA"
        ).getAllKSUPagingByParam({
          paramFilters: {
            category: body,
          },
        });

        return res.data.data?.map((item) => ({
          value: item.kodeKSU,
          label: item.name,
          satuan: item.satuanDTO?.value,
        }));
      } catch (error) {
        console.log("errors: ", error);
        return null;
      }
    case "NOQR":
      try {
        const res = await Api.create(
          "NAGAMAS_MASTER_DATA"
        ).getAllHadiahPagingByParam({
          paramFilters: {
            categoryHadiah: body,
          },
        });

        return res.data.data?.map((item) => ({
          value: item.kodeHadiah,
          label: item.nameHadiah,
          satuan: item.satuanHadiah,
        }));
      } catch (error) {
        console.log("errors: ", error);
        return null;
      }
  }
};

export const checkNonQrCanUpdate = async ({
  kodeCabang,
  kodeLocator,
  kodePart,
  receivingNumberId,
  qty,
  changesQty,
  setError,
}) => {
  const requestBody = {
    kodeCabang,
    kodeLocator,
    kodePart,
    receivingNumberId,
    qrStatus: false,
    qty,
    changesQty,
  };

  try {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkNonQrCanUpdate,
      menuName: "Check Non QR Update",
      setError,
      args: requestBody,
    });

    return response;
  } catch (error) {
    console.error("checkNonQrCanUpdate error:", error);
    throw error;
  }
};
